import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  marginRight: {
    marginRight: theme.spacing(1),
  },
}))

const SkeletonPair = ({ largerWidth }) => {
  const classes = useStyles()

  return (
    <Box display="flex">
      <Skeleton
        data-testid="loading-skeleton-testid"
        className={classes.marginRight}
        height={18}
        width={32}
      />
      <Skeleton
        data-testid="loading-skeleton-testid"
        height={18}
        width={largerWidth}
      />
    </Box>
  )
}

SkeletonPair.propTypes = {
  largerWidth: PropTypes.number,
}

SkeletonPair.defaultProps = {
  largerWidth: 60,
}

export default SkeletonPair
